export const translations = {
  pt: {
    nav: {
      about: 'Sobre',
      history: 'História',
      solutions: 'Soluções',
      clients: 'Clientes',
      contact: 'Contato',
      cta: 'Falar com especialista',
      openMenu: 'Abrir menu',
      closeMenu: 'Fechar menu',
    },
    hero: {
      eyebrow: 'Plataforma líder em gestão de fornecedores',
      heading1: 'Transformando fornecedores',
      headingAccent: 'em inteligência operacional',
      subtext: 'Homologação, compliance e marketplace integrados numa única plataforma. Mais de 60 mil fornecedores. Mais de 12 anos conectando grandes empresas aos seus melhores parceiros.',
      ctaPrimary: 'Falar com especialista',
      ctaSecondary: 'Acessar SIGEC ELOS',
      stats: [
        { value: '60k+', label: 'Fornecedores ativos' },
        { value: '7,2mi', label: 'Documentos analisados' },
        { value: '31%',   label: 'Redução de riscos' },
        { value: '12+',   label: 'Anos de experiência' },
      ],
    },
    about: {
      label: 'Quem somos',
      heading1: 'DNA de parcerias sólidas,',
      heading2: 'há mais de 12 anos no mercado',
      desc: 'A EQPI Tech é especializada em soluções sob medida e completas para os desafios da gestão de fornecedores. Nossas plataformas unem ferramentas próprias, customizações, integrações e prestação de serviço — entregando controle, compliance e rastreabilidade em toda a sua cadeia produtiva.',
      cta: 'Conheça nossas soluções',
      pillars: [
        { title: 'Gestão de contratos e fornecedores', desc: 'Larga experiência e metodologia consolidada para operar sua cadeia com eficiência e segurança.' },
        { title: '20 anos em tecnologia', desc: 'Experiência técnica profunda aplicada a processos de homologação, compliance e gestão contratual.' },
        { title: 'Eficiência + redução de custos', desc: 'Eliminação de vícios de processo, retrabalho e riscos jurídicos — com rastreabilidade total.' },
      ],
    },
    solutions: {
      label: 'Portfólio de soluções',
      heading1: 'Uma plataforma para cada etapa',
      heading2: 'da sua cadeia de fornecimento',
      desc: 'Do primeiro contato com um fornecedor até a gestão do contrato em operação — o ecossistema EQPI Tech cobre cada etapa.',
      elosAccess: 'Acessar plataforma →',
      cards: [
        {
          title: 'Homologação & Monitoramento',
          desc: 'A plataforma completa de gestão de fornecedores. Homologação, monitoramento, compliance e certificação — com monitoramento automático e proativo de vencimentos.',
          features: ['Monitoramento automático de vencimentos', 'Portal exclusivo de documentação', 'Conformidade contínua', 'Carta de Exceção e Restrição Administrativa'],
        },
        {
          title: 'Gestão de Contratos',
          desc: 'A plataforma completa de gestão de contratos e mobilização de terceiros. Controle, Medição, Desempenho e compliance — com visibilidade total no ciclo dos contratos.',
          features: ['Controle de documentos 24/7', 'Avaliação de desempenho', 'Boletim de medição automático', 'Análise Make or Buy'],
        },
        {
          title: 'Pré-homologação & Marketplace',
          desc: 'Pré-homologação e marketplace de fornecedores, conectando competência a grandes oportunidades. Vitrine qualificada com dados reais e processos auditáveis.',
          features: ['Pré-homologação automatizada', 'Marketplace B2B', 'Selo ELOS Verificado e Homologado', 'Integração com SIGEC HOC'],
        },
        {
          title: 'Background Check Completo',
          desc: 'Relatório completo de análise de empresas e parceiros. Identidade, Integridade, Listas restritivas, Jurídico e Financeiro — com score EQPI de 0 a 100.',
          features: ['Consulta CEIS, CNEP, OFAC, ONU', 'Score de risco 0–100', 'Análise Serasa integrada', 'Rastreabilidade e evidências'],
        },
        {
          title: 'Mobilização de Terceiros',
          desc: 'Outsourcing completo — sistema e mão de obra para mobilização de fornecedores fixos e eventuais. Conformidade, Documentação, SST e controle de acesso.',
          features: ['SLA de 3 dias úteis', 'Liberação de acesso integrada', 'Obrigações trabalhistas e SST', 'Notificações automáticas'],
        },
        {
          title: 'Controle de Obrigações Acessórias',
          desc: 'Outsourcing completo para o controle das obrigações acessórias dos terceiros. Trabalhista, Previdenciário e Compliance — com liberação de pagamentos integrada.',
          features: ['Validação mensal por competência', 'Liberação ou bloqueio de faturamento', 'Portal 24/7', 'Segurança jurídica documentada'],
        },
      ],
    },
    elos: {
      label: 'Destaque do portfólio',
      title: 'SIGEC ELOS',
      tagline: 'Conectando competência a grandes oportunidades',
      differentials: [
        { title: 'Ativos estratégicos', desc: 'Fornecedores com dados, compliance e inteligência de negócios — não apenas nomes.' },
        { title: 'Governança e transparência', desc: 'Vitrine qualificada com dados reais e processos auditáveis por compradores e clientes.' },
        { title: 'Novas oportunidades', desc: 'Relacionamentos, parcerias e novos contratos com rastreabilidade total do início ao fim.' },
      ],
      cta: 'Acessar SIGEC ELOS',
      journeyLabel: 'Jornada do fornecedor',
      journey: [
        { label: 'Cadastro', desc: 'CNPJ + dados cadastrais automáticos' },
        { label: 'Plano', desc: 'Verificado (R$199/ano) ou Homologado (R$690/ano)' },
        { label: 'Documentos', desc: 'Upload + validação automática' },
        { label: 'Selo ELOS', desc: 'Visibilidade no marketplace' },
      ],
      scoreTitle: 'Score de Conformidade',
      scoreDesc: 'Sistema de pontuação 0–100 com alertas de vencimento, follow-up automático e status em tempo real.',
    },
    stats: [
      { label: 'Fornecedores ativos',   detail: 'na base do ecossistema EQPI Tech' },
      { label: 'Documentos analisados', detail: 'desde o início das operações em 2014' },
      { label: 'Redução de riscos',     detail: 'em contratos de terceirização' },
      { label: 'Anos de experiência',   detail: 'no mercado brasileiro de compliance' },
    ],
    history: {
      label: 'Nossa trajetória',
      heading1: 'Mais de 12 anos construindo',
      heading2: 'o padrão em gestão de fornecedores',
      milestones: [
        { title: 'Fundação', desc: 'Surge a Equipo Info com a missão de atender as necessidades na gestão de contratos e fornecedores em grandes operações.' },
        { title: 'Lançamento do HOC', desc: 'Sistema de Homologação Cadastral, referência no controle de exigências e monitoramento documental baseado em categoria de compra.' },
        { title: 'Lançamento do SIGEC-WEB', desc: 'Plataforma expansível, configurável e integrável para gestão de contratos — atendendo múltiplos clientes de grande porte.' },
        { title: 'Inteligência com BC Report', desc: 'Ferramenta estratégica de enriquecimento e análise de informações sobre pessoas e empresas parceiras.' },
        { title: 'Integração Total', desc: 'SIGEC HOC, SIGEC WEB e BC Report formam um ecossistema inteligente para atender diversos setores da economia.' },
        { title: 'Equipo Info se torna EQPI Tech', desc: 'Nasce com o propósito de potencializar grandes setores com Inteligência Artificial, automação e integração digital.' },
      ],
    },
    benefits: {
      label: 'Para quem é',
      heading: 'Benefícios para toda a cadeia',
      buyerTitle: 'Para compradores',
      supplierTitle: 'Para fornecedores',
      buyers: [
        'Gestão padronizada e centralizada dos fornecedores',
        'Redução de riscos jurídicos e trabalhistas',
        'Análise fiscal, legal e de compliance integrada',
        'Comparação entre fornecedores em tempo real',
        'Monitoramento proativo de vencimentos',
      ],
      suppliers: [
        'Alertas antecipados de vencimentos de documentos',
        'Consultoria fiscal e legal integrada à plataforma',
        'Certificado de aprovação e presença no SIGEC ELOS',
        'Visibilidade para grandes compradores do ecossistema',
        'Score de conformidade e posicionamento no marketplace',
      ],
    },
    clients: {
      label: 'Nossos clientes',
      heading1: 'Empresas líderes de diversos setores',
      heading2: 'confiam no SIGEC',
      desc: 'De mineradoras globais a concessionárias de infraestrutura — o ecossistema EQPI Tech opera nas cadeias mais exigentes do Brasil.',
      note: '+60 mil fornecedores cadastrados no ecossistema EQPI Tech',
    },
    contact: {
      label: 'Fale conosco',
      heading1: 'Pronto para transformar',
      heading2: 'sua cadeia de fornecimento?',
      desc: 'Nossa equipe responde em até 1 dia útil.',
      form: {
        name: 'Nome *',
        namePlaceholder: 'Seu nome',
        company: 'Empresa *',
        companyPlaceholder: 'Nome da empresa',
        email: 'E-mail *',
        emailPlaceholder: 'seu@email.com',
        phone: 'Telefone',
        phonePlaceholder: '(11) 99999-9999',
        message: 'Mensagem *',
        messagePlaceholder: 'Como podemos ajudar?',
        submit: 'Enviar mensagem',
        sending: 'Enviando…',
        error: 'Erro ao enviar. Tente pelo WhatsApp abaixo.',
      },
      success: { title: 'Mensagem enviada!', desc: 'Nossa equipe entrará em contato em breve.' },
      info: {
        title: 'Contatos diretos',
        whatsapp: 'WhatsApp',
        email: 'E-mail',
        phoneBR: 'Telefone — Brasil',
        phonePT: 'Telefone — Portugal',
        support: 'Suporte técnico',
        instagram: '@eqpi.tech no Instagram',
      },
    },
    footer: {
      tagline: 'A plataforma que transforma a gestão de fornecedores em inteligência operacional.',
      solutions: 'Soluções',
      company: 'Empresa',
      contact: 'Contato',
      support: 'Suporte',
      supportVoice: 'voz',
      supportWA: 'WhatsApp Suporte',
      copyright: 'Todos os direitos reservados.',
      offices: [
        { city: 'SÃO PAULO — BRASIL', address: 'Av. Luiz Carlos Berrini, 1681\nConj. 111 e 112 — Cidade Monções' },
        { city: 'PORTO — PORTUGAL', address: 'Av. Manuel Violas, 476\nSala 8.1 — Vl. Nova de Gaia' },
      ],
      nav: ['Sobre', 'História', 'Soluções', 'Clientes', 'Contato'],
    },
    chatbot: {
      greeting: 'Olá! Sou o Assistente Virtual da EQPI Tech. Posso responder dúvidas sobre nossos produtos e serviços de gestão de fornecedores. Como posso ajudar?',
      title: 'Assistente EQPI',
      fab: 'Fale com o Assistente',
    },
  },

  en: {
    nav: {
      about: 'About',
      history: 'History',
      solutions: 'Solutions',
      clients: 'Clients',
      contact: 'Contact',
      cta: 'Talk to an expert',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
    },
    hero: {
      eyebrow: 'Leading platform for supplier management',
      heading1: 'Transforming suppliers',
      headingAccent: 'into operational intelligence',
      subtext: 'Qualification, compliance and marketplace integrated in one platform. Over 60,000 suppliers. Over 12 years connecting major companies to their best partners.',
      ctaPrimary: 'Talk to an expert',
      ctaSecondary: 'Access SIGEC ELOS',
      stats: [
        { value: '60k+', label: 'Active suppliers' },
        { value: '7.2M',  label: 'Documents analyzed' },
        { value: '31%',   label: 'Risk reduction' },
        { value: '12+',   label: 'Years of experience' },
      ],
    },
    about: {
      label: 'About us',
      heading1: 'DNA of solid partnerships,',
      heading2: 'over 12 years in the market',
      desc: 'EQPI Tech specializes in tailored, end-to-end solutions for supplier management challenges. Our platforms combine proprietary tools, customizations, integrations and service delivery — providing control, compliance and traceability across your entire supply chain.',
      cta: 'Explore our solutions',
      pillars: [
        { title: 'Contract & supplier management', desc: 'Deep expertise and consolidated methodology to operate your supply chain with efficiency and security.' },
        { title: '20 years in technology', desc: 'Extensive technical experience applied to qualification, compliance and contract management processes.' },
        { title: 'Efficiency + cost reduction', desc: 'Elimination of process inefficiencies, rework and legal risks — with full traceability.' },
      ],
    },
    solutions: {
      label: 'Solution portfolio',
      heading1: 'A platform for every stage',
      heading2: 'of your supply chain',
      desc: 'From the first contact with a supplier to active contract management — the EQPI Tech ecosystem covers every step.',
      elosAccess: 'Access platform →',
      cards: [
        {
          title: 'Qualification & Monitoring',
          desc: 'The complete supplier management platform. Qualification, monitoring, compliance and certification — with automatic and proactive expiration monitoring.',
          features: ['Automatic expiration monitoring', 'Exclusive documentation portal', 'Ongoing compliance', 'Exception and Administrative Restriction Letter'],
        },
        {
          title: 'Contract Management',
          desc: 'The complete platform for contract management and third-party mobilization. Control, Measurement, Performance and compliance — with full visibility across the contract lifecycle.',
          features: ['24/7 document control', 'Performance evaluation', 'Automatic measurement reports', 'Make or Buy analysis'],
        },
        {
          title: 'Pre-qualification & Marketplace',
          desc: 'Pre-qualification and supplier marketplace connecting competence to major opportunities. Qualified showcase with real data and auditable processes.',
          features: ['Automated pre-qualification', 'B2B Marketplace', 'ELOS Verified and Qualified Badge', 'Integration with SIGEC HOC'],
        },
        {
          title: 'Full Background Check',
          desc: 'Complete analysis report on companies and partners. Identity, Integrity, Restrictive lists, Legal and Financial — with EQPI score from 0 to 100.',
          features: ['CEIS, CNEP, OFAC, UN queries', 'Risk score 0–100', 'Integrated credit analysis', 'Traceability and evidence'],
        },
        {
          title: 'Third-Party Mobilization',
          desc: 'Full outsourcing — system and workforce for mobilizing fixed and occasional suppliers. Compliance, Documentation, OHS and access control.',
          features: ['3-business-day SLA', 'Integrated access release', 'Labor and OHS obligations', 'Automatic notifications'],
        },
        {
          title: 'Ancillary Obligations Control',
          desc: 'Full outsourcing for controlling third-party ancillary obligations. Labor, Social Security and Compliance — with integrated payment release.',
          features: ['Monthly validation by competence', 'Billing release or block', '24/7 portal', 'Documented legal security'],
        },
      ],
    },
    elos: {
      label: 'Portfolio highlight',
      title: 'SIGEC ELOS',
      tagline: 'Connecting competence to major opportunities',
      differentials: [
        { title: 'Strategic assets', desc: 'Suppliers with data, compliance and business intelligence — not just names.' },
        { title: 'Governance and transparency', desc: 'Qualified showcase with real data and auditable processes for buyers and clients.' },
        { title: 'New opportunities', desc: 'Relationships, partnerships and new contracts with full traceability from start to finish.' },
      ],
      cta: 'Access SIGEC ELOS',
      journeyLabel: 'Supplier journey',
      journey: [
        { label: 'Registration', desc: 'Tax ID + automatic company data' },
        { label: 'Plan', desc: 'Verified (R$199/yr) or Qualified (R$690/yr)' },
        { label: 'Documents', desc: 'Upload + automatic validation' },
        { label: 'ELOS Badge', desc: 'Visibility in the marketplace' },
      ],
      scoreTitle: 'Compliance Score',
      scoreDesc: 'Scoring system 0–100 with expiration alerts, automatic follow-up and real-time status.',
    },
    stats: [
      { label: 'Active suppliers',      detail: 'in the EQPI Tech ecosystem' },
      { label: 'Documents analyzed',    detail: 'since operations began in 2014' },
      { label: 'Risk reduction',        detail: 'in outsourcing contracts' },
      { label: 'Years of experience',   detail: 'in the compliance market' },
    ],
    history: {
      label: 'Our journey',
      heading1: 'Over 12 years building',
      heading2: 'the standard in supplier management',
      milestones: [
        { title: 'Founded', desc: 'Equipo Info is born with the mission of addressing contract and supplier management needs in large-scale operations.' },
        { title: 'HOC Launch', desc: 'Qualification Management System, a benchmark for compliance control and document monitoring based on purchase category.' },
        { title: 'SIGEC-WEB Launch', desc: 'Expandable, configurable and integrable platform for contract management — serving multiple large-scale clients.' },
        { title: 'Intelligence with BC Report', desc: 'Strategic tool for enriching and analyzing information on partner companies and individuals.' },
        { title: 'Full Integration', desc: 'SIGEC HOC, SIGEC WEB and BC Report form an intelligent ecosystem serving multiple sectors of the economy.' },
        { title: 'Equipo Info becomes EQPI Tech', desc: 'Born with the purpose of empowering major sectors with Artificial Intelligence, automation and digital integration.' },
      ],
    },
    benefits: {
      label: 'Who is it for',
      heading: 'Benefits across the entire supply chain',
      buyerTitle: 'For buyers',
      supplierTitle: 'For suppliers',
      buyers: [
        'Standardized and centralized supplier management',
        'Reduction of legal and labor risks',
        'Integrated fiscal, legal and compliance analysis',
        'Real-time supplier comparison',
        'Proactive expiration monitoring',
      ],
      suppliers: [
        'Early expiration alerts for documents',
        'Fiscal and legal consulting integrated into the platform',
        'Approval certificate and presence in SIGEC ELOS',
        'Visibility to major buyers in the ecosystem',
        'Compliance score and marketplace positioning',
      ],
    },
    clients: {
      label: 'Our clients',
      heading1: 'Leading companies across multiple sectors',
      heading2: 'trust SIGEC',
      desc: "From global mining companies to infrastructure concessionaires — the EQPI Tech ecosystem operates in Brazil's most demanding supply chains.",
      note: '+60,000 suppliers registered in the EQPI Tech ecosystem',
    },
    contact: {
      label: 'Get in touch',
      heading1: 'Ready to transform',
      heading2: 'your supply chain?',
      desc: 'Our team responds within 1 business day.',
      form: {
        name: 'Name *',
        namePlaceholder: 'Your name',
        company: 'Company *',
        companyPlaceholder: 'Company name',
        email: 'E-mail *',
        emailPlaceholder: 'your@email.com',
        phone: 'Phone',
        phonePlaceholder: '+1 (555) 000-0000',
        message: 'Message *',
        messagePlaceholder: 'How can we help?',
        submit: 'Send message',
        sending: 'Sending…',
        error: 'Error sending. Try via WhatsApp below.',
      },
      success: { title: 'Message sent!', desc: 'Our team will get back to you shortly.' },
      info: {
        title: 'Direct contacts',
        whatsapp: 'WhatsApp',
        email: 'E-mail',
        phoneBR: 'Phone — Brazil',
        phonePT: 'Phone — Portugal',
        support: 'Technical support',
        instagram: '@eqpi.tech on Instagram',
      },
    },
    footer: {
      tagline: 'The platform that transforms supplier management into operational intelligence.',
      solutions: 'Solutions',
      company: 'Company',
      contact: 'Contact',
      support: 'Support',
      supportVoice: 'voice',
      supportWA: 'Support WhatsApp',
      copyright: 'All rights reserved.',
      offices: [
        { city: 'SÃO PAULO — BRAZIL', address: 'Av. Luiz Carlos Berrini, 1681\nSuite 111 & 112 — Cidade Monções' },
        { city: 'PORTO — PORTUGAL', address: 'Av. Manuel Violas, 476\nSuite 8.1 — Vl. Nova de Gaia' },
      ],
      nav: ['About', 'History', 'Solutions', 'Clients', 'Contact'],
    },
    chatbot: {
      greeting: "Hello! I'm EQPI Tech's Virtual Assistant. I can answer questions about our supplier management products and services. How can I help?",
      title: 'EQPI Assistant',
      fab: 'Talk to Assistant',
    },
  },
}
